import img1 from './recursos/img/GaleriaImg/Galeria1.jpg';
import img2 from './recursos/img/GaleriaImg/Galeria2.jpg';
import img3 from './recursos/img/GaleriaImg/Galeria3.jpg';
import img4 from './recursos/img/GaleriaImg/Galeria4.jpg';
import img5 from './recursos/img/GaleriaImg/Galeria5.jpg';
import img6 from './recursos/img/GaleriaImg/Galeria6.jpg';
import img7 from './recursos/img/GaleriaImg/Galeria7.jpg';
import img8 from './recursos/img/GaleriaImg/Galeria8.jpg';
import img9 from './recursos/img/GaleriaImg/Galeria9.jpg';

export const data ={
    tipoEvento:'Nuestra Boda',
    nombres: ['Mara Patricia Barraza Marquez' , 'Iohannan Arturo cruz Morales'],
    ubicacion:'Las Maravillas Trailer Park',
    fecha: new Date(2025,4,2),
    galeria: [img1,img2,img3,img4,img5,img6,img7,img8,img9]
}